import { defineMessages } from 'react-intl';

export default defineMessages({
    success: {
        id: '_.UploadedFilesStatus.success',
        defaultMessage: '{fileName} has been uploaded successfully!'
    },
    documentUploadError: {
        id: '_.UploadedFilesStatus.document_upload_error',
        defaultMessage: '{fileName}: {error}'
    },
    duplicateDocumentError: {
        id: '_.UploadedFilesStatus.duplicate_document_error',
        defaultMessage: '{fileName}: {error}'
    },
    validationError: {
        id: '_.UploadedFilesStatus.validation_error',
        defaultMessage: '{fileName}: {error}'
    },
    defaultError: {
        id: '_.UploadedFilesStatus.default_error',
        defaultMessage: '{fileName}: {error}'
    }
});
